import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { useSpeechSynthesis } from 'react-speech-kit';
import { stripHtmlTags } from '../../../utils/utils';
import { useLocation } from 'react-router';

const ReadAloud = ({ text, onActivate, isActive }) => {
  const { speak, cancel, speaking } = useSpeechSynthesis();
  const [voice, setVoice] = useState(null);
  const location = useLocation();
  let parsedText = stripHtmlTags(text);

  const speechOptions = {
    rate: 1,
    pitch: 0.8,
    volume: 0.8,
    voice: voice, // Use preloaded voice
    onEnd: () => {
      if (onActivate) onActivate('end');
    },
  };

  // Load voices before speaking
  useEffect(() => {
    const loadVoices = () => {
      const voices = window.speechSynthesis.getVoices();
      if (voices.length) {
        // Replace 'Nova' with your desired voice name
        const novaVoice = voices.find((v) => v.name.includes('Samantha') || v.name.includes('Nova') || v.name.includes('Google US English'));
        setVoice(novaVoice || voices[0]);
      }
    };

    loadVoices();
    // Sometimes voices are loaded asynchronously
    window.speechSynthesis.onvoiceschanged = loadVoices;

    return () => {
      window.speechSynthesis.onvoiceschanged = null;
    };
  }, []);

  useEffect(() => {
    if (speaking) cancel();
  }, [location]);

  useEffect(() => {
    const handleBeforeUnload = () => window.speechSynthesis.cancel();
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.speechSynthesis.cancel();
    };
  }, []);

  const handleReadAloud = () => {
    if (onActivate) onActivate();
    cancel();
    speak({ text: parsedText, ...speechOptions });
  };

  const onStopReadAloud = () => {
    cancel();
    if (onActivate) onActivate('cancel');
  };

  return (
    <div className="read-aloud-container">
      {speaking ? (
        <FontAwesomeIcon
          icon="volume-mute"
          className="pl-1 read-aloud-icon"
          size="lg"
          title="Stop Speaking"
          style={{ color: '#12225f', cursor: 'pointer' }}
          onClick={onStopReadAloud}
        />
      ) : (
        <FontAwesomeIcon
          icon="volume-up"
          className="pl-1 read-aloud-icon"
          size="lg"
          title="Read Aloud"
          style={{ color: '#12225f', cursor: 'pointer' }}
          onClick={handleReadAloud}
        />
      )}
    </div>
  );
};

export default ReadAloud;
